import "~/loader"
import "~/controllers"
import "trix"
import "@popperjs/core"
import "bootstrap"

//------------------------------------------------------------------------
// Deprecated JS code that we should gradually move to our latest system.
//------------------------------------------------------------------------

import "~/deprecated/config" // must be in first position

import "~/components/confidence_score"
import "~/components/confirm_deletion_modal"
import "~/components/verification_icon"

import "~/deprecated/models/billing_information"
import "~/deprecated/models/onboarding_step"
import "~/deprecated/models/user"

import "~/deprecated/api_documentation/index_2"
import "~/deprecated/backoffice/calls"
import "~/deprecated/bulk_finders/configuration"
import "~/deprecated/bulk_finders/new"
import "~/deprecated/bulk_searches/new"
import "~/deprecated/bulk_verifications/new"
import "~/deprecated/connected_apps/new"
import "~/deprecated/email_finder/index_2"
import "~/deprecated/leads_imports/new"
import "~/deprecated/messages/index_2"
import "~/deprecated/registrations/new"
import "~/deprecated/requests/index_2"
import "~/deprecated/search_landing_page/show"
import "~/deprecated/sessions/new"
import "~/deprecated/teams/index_2"
import "~/deprecated/validate_phone_number/step1"
import "~/deprecated/visitors"

import "~/turbo-mount"

// Below code sets up the HTML5 dialogs for the app instead of using browser confirm dialogs.
// IF there is a checkbox with class "dont-show-again" in the dialog, it will save the user's choice in localStorage
// and not show the dialog again.
Turbo.config.forms.confirm = (message, element) => {
  let dialogId = element.dataset.confirmDialogId || "turbo-confirm"
  let dialogConfirmKey = dialogId + "-dont-show-again"
  if (localStorage.getItem(dialogConfirmKey)) { return true }

  let dialog = document.getElementById(dialogId)
  if (!dialog.open) { dialog.showModal() }

  return new Promise((resolve) => {
    dialog.addEventListener("close", () => {
      let returnValue = dialog.returnValue === "confirm"
      let shouldStoreDontShowAgainPreference = returnValue && element.dataset.confirmDialogId &&
        dialog.querySelector("input[type=checkbox].dont-show-again:checked");

      if (shouldStoreDontShowAgainPreference) { localStorage.setItem(dialogConfirmKey, "true") }

      resolve(returnValue)
    }, { once: true })
  })
}

// Below code adds easy handling of redirection from turbo frames
Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};

Turbo.StreamActions.set_style = function () {
  const name = this.getAttribute("name")
  const value = this.getAttribute("value") || ""

  if (name) {
    this.targetElements.forEach((element) => element.style.setProperty(name, value))
  } else {
    console.error(`No "name" provided for Turbo Streams operation "set_style"`)
  }
}

Turbo.StreamActions.set_attribute = function () {
  const name = this.getAttribute("name")
  const value = this.getAttribute("value") || ""

  if (name) {
    this.targetElements.forEach((element) => (element.setAttribute(name, value)))
  } else {
    console.error(`No "name" provided for Turbo Streams operation "set_attribute"`)
  }
}

Turbo.StreamActions.update_empty = function () {
  const content = this.getAttribute("content")

  if (content) {
    this.targetElements.forEach((element) => {
      // Replace only if the element is empty
      if (element.innerText.trim() === "") {
        element.innerHTML = content
      }
    })
  } else {
    console.error(`No "content" provided for Turbo Streams operation "update_empty"`)
  }
}

Turbo.StreamActions.create_tag = function () {
  const template = this.templateElement
  const targets = this.targetElements
  const assignedRecordIds = this.getAttribute("assigned_record_ids").split(",")

  if (template && targets.length > 0) {
    targets.forEach((target) => {
      const recordId = target.dataset.recordId
      const clone = template.content.cloneNode(true)

      // Replace the placeholder with the actual record ID
      const element = clone.firstElementChild
      element.innerHTML = element.innerHTML.replace(/RECORD_ID/g, recordId)

      // Set the checkbox to checked if the record ID is in the list of assigned record IDs
      element.querySelector("input[type=checkbox]").checked = assignedRecordIds.includes(recordId)

      target.prepend(clone)
    })
  } else {
    console.error(`Missing template or targets for Turbo Streams operation "create_tag"`)
  }
}

Turbo.StreamActions.turbo_frame_reload = function () {
  const element = document.getElementById(this.target)

  if (document.startViewTransition) {
    addEventListener("turbo:before-frame-render", (event) => {
      if (event.target === element) {
        const originalRender = event.detail.render

        event.detail.render = (currentElement, newElement) => {
          document.startViewTransition(() => {
            originalRender(currentElement, newElement)
          })
        }
      }
    }, { once: true })
  }

  element.reload()
}

Turbo.StreamActions.turbo_frame_set_src = function () {
  const src = this.getAttribute("src")
  this.targetElements.forEach((element => element.src = src))
}

Turbo.StreamActions.dispatch_event = function () {
  const name = this.getAttribute("name")
  let template = null

  try {
    template = this.templateContent.textContent
  } catch {
    // default to empty object
  }

  try {
    const detail = template ? JSON.parse(template) : {}

    if (name) {
      const options = { bubbles: true, cancelable: true, detail }
      const event = new CustomEvent(name, options)

      this.targetElements.forEach((element) => element.dispatchEvent(event))
    } else {
      console.warn(`no "name" provided for Turbo Streams operation "dispatch_event"`)
    }
  } catch (error) {
    console.error(
      `error proccessing provided "detail" in "<template>" ("${template}") for Turbo Streams operation "dispatch_event".`,
      `Error: "${error.message}"`,
    )
  }
}
